<template>
    <loader-component v-if="showLoader"></loader-component>
    <div v-else>
        <responsive-header-component></responsive-header-component>
        <div class="wrapper default">
            <header class="main-header default">
                <div class="container">
                    <header-component></header-component>
                </div>
            </header>
            <main v-if="!isShowMessageForm" class="profile-user-page default">
                <div class="container" style="margin-top:10px;">
                    <div class="row">
                        <h3 style="margin-left:auto;margin-right:auto;font-weight:600">فرم نظرسنجی آموزشگاه رانندگی معجزه بندرعباس</h3>
                    </div> 
                    <div class="row" style="margin-top:-15px;">
                        <h5 style="margin-left:auto;margin-right:auto;color:green">هنرآموز گرامی، <strong>{{ surveyQuestions[0].StdFullName }}</strong>، خواهشمند است در جهت بهبود و ارتقاء خدمات آموزشگاه، به سؤالات زیر پاسخ دهید</h5>
                        <!--<p v-if="surveyQuestions.length > 0">{{ surveyQuestions[0].StdFullName }}</p>-->
                    </div> 
                    <div class="row">
                        <div class="profile-page col-md-12 order-2" style="padding:15px;">
                            <div v-for="(question, index) in surveyQuestions" :key="question.SurveyQuestionID" :class="{'error': (!selectedOptions[index] && showError && !question.HasComment) || ((question.Comment == null || question.Comment == '') && showError && question.HasComment)}">
                                <h5>{{ question.Question }}</h5>
                                <div v-if="!question.HasComment" class="options">
                                    <label v-if="question.Option1 != null">
                                        <input type="radio" :name="'question_' + index" :value="1" v-model="selectedOptions[index]" />
                                        {{ question.Option1 }}
                                    </label>
                                    <label v-if="question.Option2 != null">
                                        <input type="radio" :name="'question_' + index" :value="2" v-model="selectedOptions[index]" />
                                        {{ question.Option2 }}
                                    </label>
                                    <label v-if="question.Option3 != null">
                                        <input type="radio" :name="'question_' + index" :value="3" v-model="selectedOptions[index]" />
                                        {{ question.Option3 }}
                                    </label>
                                    <label v-if="question.Option4 != null">
                                        <input type="radio" :name="'question_' + index" :value="4" v-model="selectedOptions[index]" />
                                        {{ question.Option4 }}
                                    </label>
                                </div>
                                <div v-else class="options">
                                    <label>
                                        <textarea rows="3" class="form-control" v-model="question.Comment" />
                                    </label>
                                </div>

                                <p v-if="!selectedOptions[index] && showError && !question.HasComment" class="error-message">لطفاً این سوال را پاسخ دهید</p>
                                <p v-if="(question.Comment == null || question.Comment == '') && showError && question.HasComment" class="error-message">لطفاً این سوال را پاسخ دهید</p>
                            </div>
                            <button @click="submitSurvey" class="submit-button">ثبت نظرسنجی</button>
                        </div>

                    </div>
                </div>
            </main>
            <main v-else  class="profile-user-page default">
                <div class="container" style="margin-top:10px;">
                    <div class="row">
                        <div class="profile-page col-md-12 order-2" style="padding:15px;" dir="rtl">
                            <h1 class="survey-message" v-html="message"></h1>   
                        </div>

                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return {
                showLoader: true,
                showError: false,
                surveyKey: '',
                surveyQuestions: [],
                selectedOptions: [],
                isShowMessageForm: false,
                message: ''
            };
        },
        beforeMount: function () {
            createPageTitle('نظرسنجی');
        },
        mounted() {
            this.surveyKey = this.$route.params.surveyKey; 
            httpPromise(this, '/v1/Survey/SurveyQuestions/Read', 'get', { SurveyKey: this.surveyKey },
                response => {
                    this.surveyQuestions = response.data.Value;
                    this.showLoader = false;
                    this.isShowMessageForm= false;
                },
                response => {
                    this.message = response.data.Message;
                    this.isShowMessageForm= true;
                    this.showLoader = false;
                });

        },

        methods: {
            submitSurvey() {
                const unansweredMultipleChooseQuestions = this.surveyQuestions.filter((x, index) => !this.selectedOptions[index] && !x.HasComment);
                const unansweredQuestions = this.surveyQuestions.filter((x, index) => (x.Comment == null || x.Comment == '')  && x.HasComment);
                if (unansweredMultipleChooseQuestions.length > 0 || unansweredQuestions.length > 0) {
                    this.showError = true;
                } else {
                    this.showError = false;
                    let surveyAnswers = {
                        SurveyKey: this.surveyKey,
                        SurveyAnswerDetails: this.surveyQuestions.map((question, index) => ({
                            SurveyQuestionID: question.SurveyQuestionID,
                            Comment: question.Comment,
                            SelectedOption: this.selectedOptions[index] || 0
                        }))
                    };
                    this.showLoader = true;
                    httpPromise(this, '/v1/Survey/SurveyAnswers/Add', 'post', surveyAnswers,
                        response => {
                            this.message = 'نظرسنجی شما با موفقیت در سیستم ثبت گردید' + "<br/><br/>" + "با تشکر از شما";
                            this.isShowMessageForm= true;
                            this.showLoader = false;
                        },
                        response => {
                            toastr.error(response.data.Message);
                            this.showLoader = false;
                        });

                }
            }
        }

    }
</script>

<style scoped>
    .survey-question {
        margin-bottom: 20px;
    }

        .survey-question h3 {
            font-size: 18px;
            font-weight: bold;
        }

    .options {
        margin-top: 10px;
    }

        .options label {
            display: block;
            margin-bottom: 5px;
            padding: 10px;
            background: #f9f9f9;
            border-radius: 4px;
        }

        .options input[type="radio"] {
            margin-right: 10px;
        }

    .submit-button {
        margin-top: 20px;
        padding: 10px 20px;
        background-color: #4CAF50;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }

        .submit-button:hover {
            background-color: #45a049;
        }

    .error {
        margin-bottom: 10px;
        border: 2px solid red;
        border-radius: 4px;
        padding: 10px;
    }

    .error-message {
        color: red;
        font-size: 14px;
    }





    .survey-message {
        font-size: 24px;
        font-weight: bold;
        color: #2c3e50; /* رنگ تیره و جذاب */
        text-align: center;
        background-color: #ecf0f1; /* رنگ پس‌زمینه روشن */
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* سایه زیبا */
        margin-top: 20px;
        animation: fadeIn 1s ease-in-out; /* انیمیشن ظاهر شدن */
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: scale(0.95);
        }

        to {
            opacity: 1;
            transform: scale(1);
        }
    }
</style>
